import React from 'react'
import PropTypes from 'prop-types'
import { FaEdit, FaWindowClose } from 'react-icons/fa'

import './Tasks.css'

export default function Tasks({ tasks, handleEdit, handleDelete }) {
    return (
        <ul className='tasks'>
            {tasks.map((task, index) => (
                <li key={task}>
                    <div className='text'>
                        {task}
                    </div>
                    <div className='icons'>
                        <FaEdit onClick={ (e) => handleEdit(e, index)} className='edit'/>
                        <FaWindowClose onClick={ (e) => handleDelete(e, index)} className='delete'/>
                    </div>
                </li>
            ))}
        </ul>
    )
}

Tasks.propTypes = {
    tasks: PropTypes.array.isRequired,
    handleEdit: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired
}